import React from "react";

const Pagination = ({ total, limit, page, onPageChange }) => {
  const totalPages = Math.ceil(total / limit);

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      // Show all if pages are small
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="pagination-panel px-4 py-4 d-flex justify-content-between align-items-center">
      <nav aria-label="Page navigation">
        <ul className="pagination mb-0 py-2">
          {/* Previous Button */}
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
          </li>

          {/* Page Numbers with Ellipsis */}
          {getPageNumbers().map((p, index) => (
            <li
              key={index}
              className={`page-item ${p === page ? "active" : ""} ${p === "..." ? "disabled" : ""}`}
            >
              {p === "..." ? (
                <span className="page-link">...</span>
              ) : (
                <button className="page-link" onClick={() => onPageChange(p)}>
                  {p}
                </button>
              )}
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(page + 1)}
              disabled={page === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>

      {/* Info */}
      <div className="pagination-info py-2">
        Showing {(page - 1) * limit + 1}–{Math.min(page * limit, total)} of {total} items
      </div>
    </div>
  );
};

export default Pagination;
